import React from 'react'
import LoginP from '../components/login/LoginP'

function Login() {
  return (
    <div>
        <LoginP/>
    </div>
  )
}

export default Login